import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { getGroupByCkNorme, getTipoAmministrazioneFieldByCkNorme } from '../common/helpers/norme-ck-lookup.helper';
import { isBefore } from 'date-fns';
import { CkNormeValuesEnum } from '../common/consts/ckNormeValues.enum';
import { toNum } from '@shared/helpers/math.helper';

export const my_CkScadenzaOrgAmmHelper = (myVerbale: MyVerbale, ckNormeValue: CkNormeValues): string => {
    const my_CkScadenzaOrgAmm = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_CkScadenzaOrgAmm;
    const tipoAmministrazioneGroup = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo[getGroupByCkNorme(ckNormeValue)];
    const my_CkTipoAmministrazione = tipoAmministrazioneGroup[getTipoAmministrazioneFieldByCkNorme(ckNormeValue)];

    if (!(toNum(my_CkScadenzaOrgAmm) === -1 || toNum(my_CkTipoAmministrazione) !== 1)) {
        return 'Verificare la scadenza del CDA';
    } else {
        return null;
    }
};

export const my_CalcObbOrganoContrHelper = (myVerbale: MyVerbale, ckNormeValue: CkNormeValues): string => {
    const ammControllo = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo;
    const my_CalcObbOrganoContr = ammControllo.my_CalcObbOrganoContr;
    const assembNominSind =
        ckNormeValue === CkNormeValuesEnum.normeSrl ? ammControllo.my_NormeSrl.my_CkSrlAssembNominSind : ammControllo.my_NormeSpaOrdinario.my_CkSpoAssembNominSind;

    if (my_CalcObbOrganoContr === 'true' && assembNominSind === '0') {
        return "La cooperativa deve avere l'organo di controllo";
    } else {
        return null;
    }
};

export const my_AllElemConsiglioAmministrazioneHelper = (myVerbale: MyVerbale, ckNormeValue: CkNormeValues): string => {
    const my_DataRevisioneDal = myVerbale.my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal;
    const my_AllElemConsiglioAmministrazione = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo.my_AllConsiglioAmministrazione.my_AllElemConsiglioAmministrazione;
    const tipoAmministrazioneGroup = myVerbale.my_SezioneI__Rilevazione.my_AmministrazioneControllo[getGroupByCkNorme(ckNormeValue)];
    const my_CkTipoAmministrazione = tipoAmministrazioneGroup[getTipoAmministrazioneFieldByCkNorme(ckNormeValue)];

    const date = new Date(my_DataRevisioneDal);
    const dateBefore = isBefore(date, new Date('01-01-2018'));

    if (!(my_CkTipoAmministrazione != '1' || dateBefore || my_AllElemConsiglioAmministrazione.length >= 3)) {
        return "Attenzione : per le modifiche introdotte dalla legge di bilancio 2018, l'amministrazione della cooperativa non può essere affidata ad un CDA con meno di tre componenti";
    } else {
        return null;
    }
};
